import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { alpha, Box, Tooltip } from "@mui/material";
import type { PointerEvent } from "react";

interface InsightWorkspaceSplitDividerProps {
  accentColor: string;
  onPointerDown: (event: PointerEvent<HTMLDivElement>) => void;
  onPointerMove: (event: PointerEvent<HTMLDivElement>) => void;
  onPointerUp: (event: PointerEvent<HTMLDivElement>) => void;
}

export function InsightWorkspaceSplitDivider({
  accentColor,
  onPointerDown,
  onPointerMove,
  onPointerUp,
}: InsightWorkspaceSplitDividerProps) {
  return (
    <Tooltip title="Arraste para ajustar a largura dos painéis" arrow placement="right">
      <Box
        role="separator"
        aria-orientation="vertical"
        aria-label="Ajustar largura dos painéis"
        tabIndex={0}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerUp}
        sx={{
          flexShrink: 0,
          width: 16,
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: 0,
          cursor: "col-resize",
          touchAction: "none",
          "&:hover, &:focus-visible": {
            "& .grip-knob": {
              borderColor: alpha(accentColor, 0.55),
              bgcolor: alpha(accentColor, 0.06),
            },
            "& .split-line": {
              bgcolor: alpha(accentColor, 0.4),
            },
          },
          "&:focus-visible .grip-knob": {
            outline: `2px solid ${alpha(accentColor, 0.3)}`,
            outlineOffset: 2,
          },
        }}
      >
        <Box
          className="grip-knob"
          sx={{
            width: 34,
            height: 34,
            flexShrink: 0,
            mt: 1.25,
            mb: 1,
            borderRadius: "50%",
            border: "1px solid",
            borderColor: alpha(accentColor, 0.35),
            bgcolor: "background.paper",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: alpha(accentColor, 0.75),
            transition: "border-color 0.15s ease, background-color 0.15s ease",
            pointerEvents: "none",
          }}
        >
          <DragIndicatorIcon sx={{ fontSize: 22, transform: "rotate(90deg)" }} />
        </Box>
        <Box
          className="split-line"
          sx={{
            flex: 1,
            width: 2,
            minHeight: 48,
            borderRadius: 1,
            bgcolor: alpha(accentColor, 0.22),
            transition: "background-color 0.15s ease",
          }}
        />
      </Box>
    </Tooltip>
  );
}
